import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"

//
import { useDispatch, useSelector } from "react-redux"

// Redux
import { connect } from "react-redux"
import { Link, NavLink } from "react-router-dom"
import withRouter from "components/Common/withRouter"

import { GetProfileStart, getEmpProfileStart } from "store/actions"

// users
import defaultAvatar from "../../../assets/images/users/defaultAvatar.png"

const ProfileMenu = props => {
  // useDispatch
  const dispatch = useDispatch()

  const { ProfileData } = useSelector(state => state.Profile)
  const { employeeData } = useSelector(state => state.employeeReducer)

  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  const [username, setusername] = useState("Admin")

  const [profileURL, setProfileURL] = useState("/profile")
  const [userType, setUserType] = useState(
    JSON.parse(localStorage.getItem("WWINGS_USER_TYPE"))
  )
  const [profilePic, setProfilePic] = useState(defaultAvatar)
  useEffect(() => {
    const handleStorageChange = () => {
      setUserType(JSON.parse(localStorage.getItem("WWINGS_USER_TYPE")))
    }

    window.addEventListener("storage", handleStorageChange)

    return () => {
      window.removeEventListener("storage", handleStorageChange)
    }
  }, [])

  useEffect(() => {
    if (userType === "Employee") {
      dispatch(getEmpProfileStart())
      setProfileURL("/employee-profile")
    } else {
      dispatch(GetProfileStart())
      setProfileURL("/profile")
    }
  }, [userType])

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"))
        setusername(obj.displayName)
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"))
        setusername(obj.username)
      }
    }
  }, [props.success])

  useEffect(() => {
    if (ProfileData && ProfileData.avatar) {
      setProfilePic(ProfileData.avatar)
    }
    if (employeeData && employeeData.avatar) {
      setProfilePic(employeeData.avatar)
    }

    // setProfilePic(localStorage.getItem("WWINGS_USER_INFO") ? JSON.parse(localStorage.getItem("WWINGS_USER_INFO")).avatar : "")
  }, [ProfileData, employeeData])
  let avatar = localStorage.getItem('avatar');
  const Psrc = (avatar !== "") ? avatar : defaultAvatar;
  
    
  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={Psrc}
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">{username}</span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {userType === "Employee" ? (
            <DropdownItem>
              <NavLink to={"/employee-profile"}>
              <i className="bx bx-user font-size-16 align-middle me-1" />
              {props.t("Profile")}{" "}
              </NavLink>

            </DropdownItem>
          ) : (
            <DropdownItem>
              <NavLink to={"/profile"}>
                {" "}
                <i className="bx bx-user font-size-16 align-middle me-1" />
                {props.t("Profile")}{" "}
              </NavLink>
            </DropdownItem>
          )}

         {/* <DropdownItem tag="a" href="/crypto-wallet">
            <i className="bx bx-wallet font-size-16 align-middle me-1" />
            {props.t("My Wallet")}
          </DropdownItem>  */}
          {/* <DropdownItem tag="a" href="#">
            <span className="badge bg-success float-end">11</span>
            <i className="bx bx-wrench font-size-16 align-middle me-1" />
            {props.t("Settings")}
          </DropdownItem>
          <DropdownItem tag="a" href="auth-lock-screen">
            <i className="bx bx-lock-open font-size-16 align-middle me-1" />
            {props.t("Lock screen")}
          </DropdownItem>
          <div className="dropdown-divider" /> */}
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
